import { COUNTRIES } from '../data/countries';

export const findCountryByCode = (code?: string | null) => {
  if (!code) {
    return undefined;
  }

  const normalized = code.trim().toUpperCase();
  return COUNTRIES.find((country) => country.code === normalized);
};

export const getCountryNameByCode = (code?: string | null): string | undefined => {
  const match = findCountryByCode(code);
  return match?.name;
};

// ---------------------------------------------------------------------------
// Compatibility exports used by unit tests
// ---------------------------------------------------------------------------

export const getCountryByCode = findCountryByCode;

export const getCountryByName = (name?: string | null) => {
  if (!name) return undefined;
  const normalized = name.trim().toLowerCase();
  if (!normalized) return undefined;

  // Common localized / diacritic variants used in tests and UI
  const aliasMap: Record<string, string> = {
    "côte d'ivoire": "côte d'ivoire",
    "cote d'ivoire": "côte d'ivoire",
    'россия': 'russia',
    'российская федерация': 'russia',
    '中国': 'china',
  };

  const stripDiacritics = (s: string) =>
    s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  const canonical = aliasMap[normalized] || normalized;
  const canonicalStripped = stripDiacritics(canonical);

  return COUNTRIES.find((c) => {
    const candidate = c.name.toLowerCase();
    return (
      candidate === canonical ||
      stripDiacritics(candidate) === canonicalStripped
    );
  });
};

export const getAllCountries = () => {
  // return a copy sorted by name
  return [...COUNTRIES].sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));
};
